/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Services_LabelInputs */

const en_home_services_label = /** @type {(inputs: Home_Services_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Included With Your Policy`)
};

const fr_home_services_label = /** @type {(inputs: Home_Services_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inclus dans votre police`)
};

/**
* | output |
* | --- |
* | "Included With Your Policy" |
*
* @param {Home_Services_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_services_label = /** @type {((inputs?: Home_Services_LabelInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Services_LabelInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_services_label(inputs)
	return fr_home_services_label(inputs)
});